<template>
    <div id="visit-documents-hos-pal">
        <div class="upload-header py-1">
            <h6 class="d-inline mr-auto">Attachments</h6>

            <div
                class="d-flex align-items-center justify-content-between"
                v-if="!uploadFile && addPatientDocumentsPermission"
            >
                <span>
                    Click Add Attachment to upload files associated with this task. Once uploaded, files will appear
                    below
                </span>
                <div>
                    <button
                        type="button"
                        @click="toggleUploadFile"
                        class="btn btn-primary border border-primary"
                        :disabled="isPlanner"
                    >
                        Add Attachment
                    </button>
                </div>
            </div>

            <div class="w-100" v-if="uploadFile && addPatientDocumentsPermission">
                <AddAttachmentsFormHosPal
                    :visitDetails="visitDetails"
                    :toggleUploadFile="toggleUploadFile"
                    v-on:attachmentsRefresh="loadAttchments"
                />
            </div>
        </div>
        <div class="upload-filters">
            <slot name="document-filters"></slot>
        </div>
        <div class="doc-body">
            <table class="table table-responsive-md borderless">
                <thead>
                    <tr class="bg-table-header">
                        <th>File</th>
                        <th>Document Type</th>
                        <th>Last Updated</th>
                        <th class="text-right">Actions</th>
                    </tr>
                </thead>
                <tbody v-if="taskAttchments?.length == 0 && !loadingDocuments">
                    <TableEmpty :col-span="5" component="attachments" secondary-message="No Attachments to Display" />
                </tbody>
                <tbody v-else>
                    <template v-if="loadingDocuments">
                        <tr v-for="i in loadingCount" :key="i">
                            <td><span class="shimmer-loading block-size-8"></span></td>
                            <td><span class="shimmer-loading block-size-6"></span></td>
                            <td><span class="shimmer-loading block-size-6"></span></td>
                            <td><span class="shimmer-loading block-size-4"></span></td>
                        </tr>
                    </template>

                    <template v-if="!loadingDocuments">
                        <tr v-for="document in taskAttchments" :key="document.Id">
                            <td>
                                <i class="far fa-file me-1 fa-lg"></i>
                                <a href="javascript:void(0);" @click="downloadDocuments(document)">{{
                                    document.DocumentName
                                }}</a>
                            </td>
                            <td>{{ document?.UploadType }}</td>
                            <td>{{ formatDate(document.LastUpdated) }}</td>
                            <!-- DELETE -->
                            <td colspan="4" v-if="documentToDelete === document?.Id">
                                <TablePrompt
                                    ok-text="Delete"
                                    cancelText="Cancel"
                                    operation=" "
                                    name="Delete"
                                    :includeYes="true"
                                    :isInProgress="isDeleteInProgress"
                                    :ok="deleteSelectedDocument"
                                    :cancel="cancelDeleteAttachment"
                                />
                            </td>
                            <!-- ACTIONS  -->
                            <td class="text-right" v-else>
                                <template v-if="editPatientDocumentsPermission || deletePatientDocumentsPermission">
                                    <button
                                        type="button"
                                        class="btn table-btn btn-outline-danger"
                                        @click="requestDelete(document?.Id)"
                                        v-tooltip="{ title: 'Delete' }"
                                        v-if="deletePatientDocumentsPermission"
                                        :disabled="isPlanner"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="btn table-btn btn-outline-info au-target"
                                        @click="openSelectedDocument(document)"
                                        v-tooltip="{ title: 'View' }"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </button>
                                </template>
                                <i class="text-default" v-else>No Actions</i>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" src="./VisitDocumentsHosPal.ts" />
<style lang="scss" src="./VisitDocumentsHosPal.scss"></style>
